controllers.controller('PraxisController', [
    '$scope', '$state', '$filter', '$timeout', '$ionicLoading', '$q', '$sce',
    'LocaleService', 'config', 'Validator', 'Storage', 'constants', 'ServerTimeService', 'Utils', 'UserService', '$cookies', 'API', 'ErrorService',
    function ($scope, $state, $filter, $timeout, $ionicLoading, $q, $sce, LocaleService, config, Validator, Storage, Const,
              ServerTimeService, Utils, UserService, $cookies, API, ErrorService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        self.iframeEl = null;

        $scope.user = UserService.get();

        $scope.paymentMethods = Storage.get('paymentMethods') || [];

        $scope.iframeUrl = $sce.trustAsResourceUrl('about:blank');
        $scope.urlReady = false;

        $scope.lang = LocaleService.lang;
        
        $scope.modal = {
            actionText: LocaleService.translation.try_again,
            state: false
        };

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'PraxisController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        function doPayment(iframe) {
            var request = {
                clearedby: "praxis",
                lang: $scope.lang,
                remarketing: $cookies.get('remarketing') || ''
            };

            $ionicLoading.show();

            return API.initializeTransfer(request)
                .then(checkResponse)
                .then(function (response) {
                    $scope.urlReady = true;
                    iframe.getElementsByTagName('body')[0].appendChild(Utils.generateForm(response.RedirectURL, response.PostData));
                    iframe.getElementById('form3ds').submit();
                    API.subscribe('depositConfirm', clearPayment);
                })
                .catch(function (error) {
                    return $scope.iframeLoadFail();
                })
        }

        function clearPayment(confirmResponse) {
            API.unsubscribe('depositConfirm');
            $cookies.get('remarketing') && $cookies.remove('remarketing');
        }

        $scope.iframeLoad = function () {
            $ionicLoading.hide();
            $scope.iframeReady = true;
            if ($scope.urlReady) return; //prevent second load with new url after form submit
            self.iframeEl = angular.element(document).find('iframe')[0];
            return doPayment(self.iframeEl.contentDocument || self.iframeEl.contentWindow.document);
        };

        $scope.iframeLoadFail = function () {
            $ionicLoading.hide();
            $scope.iframeReady = false;
            $scope.iframeUrl = $sce.trustAsResourceUrl('about:blank');

            $scope.modal.isError = true;
            $scope.modal.textTitle = LocaleService.translation.messages.general_error;
            $scope.modal.textContent = LocaleService.translation.messages.general_error_text;
            $scope.modal.actionText = $scope.paymentMethods.length > 1 ? LocaleService.translation.try_again : LocaleService.translation.close;
            $scope.modal.back = $scope.paymentMethods.length > 1 ? 'root.app.wallet' : 'root.app.assets';
            $scope.modal.state = true;
        };


        function clear() {
            $scope.iframeReady = false;
            $scope.iframeUrl = $sce.trustAsResourceUrl('about:blank');
            $scope.user = null;
        }

        $scope.$on('$ionicView.afterLeave', clear);
        $scope.$on('clear', clear);
    }
]);
